import $ from "jquery"
/* eslint-disable
    no-unused-vars,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import SpinnerView from "views/spinner_view"

let Imagebox
// Call on the <figure>: new Imagebox($('figure.zoomable'))

export default Imagebox = class Imagebox {
  constructor(elements) {
    this.showImagebox = this.showImagebox.bind(this)
    $(elements)
      .append('<div class="enlarge_hint"></div>')
      .click((event) => {
        event.preventDefault()
        return this.showImagebox($(event.currentTarget)[0].href)
      })
  }

  loadImage(uri, callback) {
    const img = $(new Image())
    let completed = false

    img.appendTo("body").hide()

    const complete = () => {
      if (completed) return

      completed = true
      img.off(".imagebox")
      img.data("dimensions", { x: img.width(), y: img.height() })
      return callback(img)
    }

    img.on("load.imagebox error.imagebox", complete)
    img.attr("src", uri)

    // Handle successfully cached images that may not emit a follow-up load event.
    if (img[0].complete && img[0].naturalWidth > 0) complete()

    return img
  }

  showImagebox(uri) {
    $("div.imagebox").remove()

    // Remove any lingering keydown listeners before making a new one
    $(document).off("keydown.imagebox")

    $("<div />")
      .addClass("imagebox")
      .appendTo("body")
      .click(function () {
        $(document).off("keydown.imagebox")
        return $(this).remove()
      })

    $(document).on("keydown.imagebox", (e) => {
      if (e.key === "Escape" || e.keyCode === 27) {
        $("div.imagebox").click()
      }
    })

    new SpinnerView({ centered: true, size: "50px" }).$el.appendTo($("body div.imagebox"))

    return this.loadImage(uri, (img) => {
      $("div.imagebox")
        .html(img.addClass("appearing").show())
        .click(function () {
          return $(window).unbind("resize", this.positionImagebox)
        })
      setTimeout(() => $("div.imagebox img").removeClass("appearing"), 10)
      this.positionImagebox()
      return $(window).resize(this.positionImagebox)
    })
  }

  positionImagebox() {
    const padding = 18 // $baseline * 3
    const img = $("div.imagebox img")
    const orig = img.data("dimensions")
    const page = {
      x: $(window).width() - padding - padding,
      y: $(window).height() - padding - padding,
    }
    const ratios = {
      orig: orig.x / orig.y,
      page: page.x / page.y,
    }
    let renderWidth = ratios.orig >= ratios.page ? page.x : (page.x * ratios.orig) / ratios.page
    if (renderWidth > orig.x) {
      renderWidth = orig.x
    }
    return img.css({
      width: `${renderWidth}px`,
      left: `${Math.max(padding, padding + (page.x - renderWidth) / 2)}px`,
      top: `${Math.max(padding, padding + (page.y - renderWidth / ratios.orig) / 2)}px`,
    })
  }
}
